export const RoomRating = () => {
    return (
        <div className="flex flex-row gap-1.5 items-baseline">
            <span className="font-medium text-[32px] leading-8 text-valley-dark-green">
                -
            </span>
            <span className="font-light text-2xl leading-6 text-valley-light-gray">
                / 5
            </span>
        </div>
    )
}